const UNAUTHORIZED_USER_STATUS = 401;
const CONVTYPE_COUNT = 20;
const DATE_FORMAT = 'YYYY-MM-DD'
const DATE_FORMAT_HOUR = 'YYYY-MM-DD hh:mm'
const LAST_HOUR_FLAG_VALUE = 'lasthour'
const NA_VALUE = 'N/A';
const TOTAL_TEXT = 'Total:'
const SESSION_OBJECT_KEY = 'sessionObject'
const SETTINGS_TIME_EXPIRED_MIN = 10
const ALLOWED_TRAFFIC = 'All traffic types'
const ALL_COUNTRIES_ALLOWED = 'All countries allowed'
const COPY_NOTIFICATION = 'URL copied to clipboard'
const DEFAULT_GROUPING_BY_DATE = ['date']
const GROUPING_BY_OFFER = ['campaign']
const STATUS_CAMPAIGN_DELETED = 3
const LANGUAGES = [
  { value: 'ch', label: '中国' },
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
  { value: 'ru', label: 'Russian' },
]
const CURRENCY_OPTIONS_LIST = {
  USD: '$',
  EUR: '€',
  CAD: '$',
  HKD: '$',
  ISK: 'Kr',
  PHP: '₱',
  DKK: 'kr',
  HUF: 'Ft',
  CZK: 'Kč',
  AUD: '$',
  RON: 'L',
  SEK: 'kr',
  IDR: 'Rp',
  INR: '₹',
  BRL: 'R$',
  RUB: 'р.',
  HRK: 'Kn',
  JPY: '¥',
  THB: '฿',
  CHF: '₣',
  SGD: '$',
  PLN: 'zł',
  BGN: 'лв',
  TRY: '₤',
  CNY: '¥',
  NOK: 'kr',
  NZD: '$',
  ZAR: 'R',
  MXN: '$',
  ILS: '₪',
  GBP: '£',
  KRW: '₩',
  MYR: 'RM',
}
const DEFAULT_CURRENCY_SIGN = '$'


const PAGINATION_OPTIONS = [
  {
    label: 'Disabled',
    value: 100000,
  },
  {
    label: '100',
    value: 100,
  },
  {
    label: '500',
    value: 500,
  },
  {
    label: '750',
    value: 750,
  },
  {
    label: '1000',
    value: 1000,
  },
];
export {
  CONVTYPE_COUNT,
  DATE_FORMAT,
  DATE_FORMAT_HOUR,
  LAST_HOUR_FLAG_VALUE,
  NA_VALUE,
  ALLOWED_TRAFFIC,
  COPY_NOTIFICATION,
  ALL_COUNTRIES_ALLOWED,
  STATUS_CAMPAIGN_DELETED,
  TOTAL_TEXT,
  DEFAULT_GROUPING_BY_DATE,
  GROUPING_BY_OFFER,
  UNAUTHORIZED_USER_STATUS,
  SESSION_OBJECT_KEY,
  SETTINGS_TIME_EXPIRED_MIN,
  LANGUAGES,
  CURRENCY_OPTIONS_LIST,
  DEFAULT_CURRENCY_SIGN,
  PAGINATION_OPTIONS,
}
